import React from "react";
import {Route} from "react-router-dom";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import Cookies from "js-cookie";
import {sessionStore} from "../../utils/sessionStore";
import CancellationReasons from "../../views/cancellationReasons/cancellationReasons";

let routes = [];
const token = sessionStore.get("token") ?? (Cookies.get("_f") ? JSON.parse(Cookies.get("_f").toString()) : null);

if (token) {
    routes.push([
        <Route
            path="/cancellation_reasons"
            component={RequireAuthentication(CancellationReasons)}
            key="cancellation_reasons"
            exact
        />,
    ])
}

export default routes;
